import { loginRequest, getProfile } from "../services/authService";

export function useAuth() {
  async function login(username, password) {
    // Puede lanzar Error — LoginPage lo captura y muestra al usuario
    const data = await loginRequest(username, password);
    localStorage.setItem("access_token", data.access);
    localStorage.setItem("refresh_token", data.refresh);
    console.log(data.access);

    const perfil = await getProfile();
    const condominioId = perfil?.usuario_condominio?.condominio?.id;
    if (condominioId) {
      localStorage.setItem("condominioId", String(condominioId));
    }
    // Guardar is_superuser para mostrar/ocultar panel admin en el sidebar
    localStorage.setItem("is_superuser", perfil?.is_superuser ? "true" : "false");

    return data;
  }

  function logout() {
    localStorage.clear();
    window.location.href = "/login";
  }

  function isAuthenticated() {
    const token = localStorage.getItem("access_token");
    const refresh = localStorage.getItem("refresh_token");
    return Boolean(token && refresh);
  }

  return { login, logout, isAuthenticated };
}
